<span class="status-pill" [class]="'status-pill tone-' + tone">
  <ion-icon *ngIf="icon" [name]="icon" aria-hidden="true"></ion-icon>
  <span>{{ label }}</span>
</span>